module.exports = __webpack_public_path__ + "static/img/monitor-dialog-bg.821af4a0.png";